export const checkIfAuthenticated = (state) => state.auth.isAuthenticated;
export const loginError = (state) => state.auth.errors;
export const getCurrentUser = (state) => state.auth.user;
export const getCurrentOverview = (state) => state.auth.overview;